<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div :class="['multiselect tags-fields', { disabled }]">
      <div class="multiselect__tags">
        <span
          v-for="(tag, index) in tagsList"
          :key="tag"
          class="multiselect__tag"
        >
          <span>{{ tag }}</span>
          <i class="multiselect__tag-icon" @click="remove(index)"></i>
        </span>
        <input
          type="text"
          placeholder="Enter a Tag"
          class="multiselect__input tag-input"
          @keydown.enter="add"
          @keydown.188="add"
          @keydown.delete="removeLast"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'

const TAGS_DELIMITER = ','

export default {
  name: 'FormTags',
  mixins: [ FormMixin ],
  components: { FormLabel },
  props: {
    value: {
      default: '',
      type: String,
    },
  },
  computed: {
    tagsList: {
      get () {
        return this.value.split(TAGS_DELIMITER).map(i => i.trim()).filter(i => i)
      },
      set (tagsArray) {
        this.$emit(
          'input',
          tagsArray.join(`${TAGS_DELIMITER} `)
        )
      },
    },
  },
  methods: {
    add (event) {
      event.preventDefault()
      const val = event.target.value.trim()
      if (val.length > 0) {
        this.tagsList = [
          ...this.tagsList,
          val,
        ]
        event.target.value = ''
      }
    },
    remove (index) {
      const tempList = [ ...this.tagsList ]
      tempList.splice(index, 1)
      this.tagsList = tempList
    },
    removeLast () {
      if (this.tagsList.length > 0) {
        this.remove(this.tagsList.length - 1)
      }
    },
  },
}
</script>

<style scoped>
.tag-input {
  vertical-align: top;
  margin: 5px 5px 0 0;
  color: var(--dark);
  font-size: 1rem;
}
.tag-input::placeholder {
  color: var(--text-muted);
}
</style>
